import * as utils from '../utils';

export enum MessageType {
    Info = 'INFO',
    Confirm = 'CONFIRM'
}

export interface Message {
    id: string;
    type: MessageType;
    title: string;
    message: string;
    error?: Error;
    onConfirm?: () => Promise<boolean>;
}

export function createMessage(title: string, message: string, error?: Error): Message {
    return {
        id: utils.uuidv4(),
        type: MessageType.Info,
        title,
        message,
        error
    };
}

export function createConfirm(title: string, message: string, onConfirm: () => Promise<boolean>): Message {
    return {
        id: utils.uuidv4(),
        type: MessageType.Confirm,
        title,
        message,
        onConfirm
    }
}